import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { awards, certificates } from '../data/recognition';
export function AwardsHonours() {
  return <ol className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-49" data-mp="137akjxe59740">
      {awards.map(item => {
      const cert = certificates.find(c => c.id === item.certificateId);
      return <li key={item.title} className={`flex items-center gap-4 rounded-md border px-4 py-3.5 ${item.featured ? 'border-violet/60 bg-violet/15' : 'border-rule bg-cream-deep'}`} data-id="element-50" data-mp="tazale210tcq">
            <span className={`flex h-11 min-w-[3.5rem] shrink-0 items-center justify-center rounded-full border px-3 font-serif text-sm font-semibold ${item.featured ? 'border-wheat text-wheat' : 'border-wheat bg-wheat-soft text-wheat-dark'}`} data-id="element-51" data-mp="fjawj587vut4">
              {item.short}
            </span>
            <span className="min-w-0 flex-1" data-id="element-52" data-mp="nbqs18ky6r5">
              <span className={`block text-sm leading-snug ${item.featured ? 'text-forest' : 'text-charcoal'}`} data-id="element-53" data-mp="2uqemf6byyx9u">
                {item.title}
              </span>
              {cert && <a href={cert.url} target="_blank" rel="noreferrer" aria-label={`View certificate: ${item.title} (PDF)`} className={`mt-1 inline-flex items-center gap-0.5 text-xs font-semibold transition-colors duration-150 ${item.featured ? 'text-wheat hover:text-forest' : 'text-cyan hover:text-forest'}`} data-id="element-54" data-mp="2kt0gi0no9qvs">
                  Certificate
                  <ArrowUpRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-55" data-mp="38icnquzfvovg" />
                </a>}
            </span>
            <span className={`shrink-0 text-sm font-medium tabular-nums ${item.featured ? 'text-wheat' : 'text-charcoal-muted'}`} data-id="element-56" data-mp="1s3tjx77s3bd6">
              {item.year}
            </span>
          </li>;
    })}
    </ol>;
}